export class DatosBasicos { 
    primerNombre: string;
    segundoNombre: string;
    primerApellido: string;
    segundoApellido: string;
    edad: Number;
    genero: string;
    fechaNacimiento: string;
    
    static instance() {
      return new this();
    }
  }